export { default as ImmediateDeliveryIcon } from "./date.svg";
export { default as ProjectTypeIcon } from "./project_type.svg";
export { default as PercentageIcon } from "./percentage.svg";
export { default as LocationIcon } from "./location.svg";
export { default as LandAreaIcon } from "./land_area.svg";
export { default as HousingTypeIcon } from "./housing_type.svg";
export { default as HousingCountIcon } from "./housing_count.svg";
export { default as GroundSurveyIcon } from "./ground_survey.svg";
export { default as EarthquakeRegulationsIcon } from "./earthquake_regulations.svg";
export { default as CatalogIcon  } from "./catalog.svg";
